import React from 'react'
import styled, { keyframes } from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import StaticImage from '@components/images/StaticImg'
import { PRESS_HEADING, pressLogos } from '../content'
import { hairline, muted, surface } from '../styled'

const scroll = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`

const Frame = styled.div`
  background: ${surface};
  padding: 20px 0 24px;
  overflow: hidden;
  border-bottom: 1px solid ${hairline};
`

const Heading = styled.div`
  text-align: center;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.14em;
  color: ${muted};
  text-transform: uppercase;
  margin-bottom: 14px;
`

const Track = styled.div`
  display: flex;
  width: max-content;
  align-items: center;
  animation: ${scroll} 28s linear infinite;

  ${Frame}:hover & {
    animation-play-state: paused;
  }

  /* a static, wrapped row of the logos once, without the loop's second copy */
  @media (prefers-reduced-motion: reduce) {
    animation: none;
    flex-wrap: wrap;
    justify-content: center;
    width: auto;
  }
`

const Item = styled.div`
  display: flex;
  align-items: center;
  height: ${(props) => props.$phoneHeight || (props.$large ? 46 : 40)}px;
  padding: 0 26px;
  border-right: 1px solid #dddddd;

  flex: 0 0 auto;

  @media (prefers-reduced-motion: reduce) {
    &[aria-hidden='true'] {
      display: none;
    }
  }

  ${media.sm`
    height: ${(props) => (props.$large ? 64 : 56)}px;
    padding: 0 clamp(36px, 5vw, 56px);
  `}

  img {
    height: 100%;
    width: auto;
    object-fit: contain;
    filter: grayscale(1) contrast(1.1) opacity(0.95);
  }
`

/**
 * Scrolling logo strip. The list is duplicated so the -50% translation loops seamlessly;
 * it pauses on hover and stands still for reduced motion.
 *
 * @param heading  overrides the default label. The paid-social page says
 *                 "As featured in" where the site pages say "As seen in".
 * @param large    slightly bigger logos, as the paid-social page asks
 * @param phoneHeight  logo height in px on phones only, where the default reads small
 */
const PressMarquee = ({ heading = PRESS_HEADING, large = false, phoneHeight }) => (
  <Frame>
    <Heading>{heading}</Heading>
    <Track>
      {[...pressLogos, ...pressLogos].map((logo, index) => (
        <Item
          key={`${logo.name}-${index}`}
          $large={large}
          $phoneHeight={phoneHeight}
          aria-hidden={index >= pressLogos.length ? 'true' : undefined}
        >
          <StaticImage src={logo.src} alt={logo.alt} />
        </Item>
      ))}
    </Track>
  </Frame>
)

export default PressMarquee
